import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the msTeamsVerify state domain
 */

const selectMsTeamsVerifyDomain = state => state.msTeamsVerify || initialState;

const makeSelectMsTeamsVerifyState = () =>
  createSelector(selectMsTeamsVerifyDomain, subState => subState);

/**
 * Other specific selectors
 */

const makeSelectIsVerify = () =>
  createSelector(selectMsTeamsVerifyDomain, subState => subState.isVerify);

const makeSelectError = () => createSelector(selectMsTeamsVerifyDomain, subState => subState.error);

export { makeSelectIsVerify, makeSelectError };
